import $ from "jquery";
import * as preact from "preact";

import * as modalDialog from "modalDialog";
import EditCardView from "views/EditCardView";

interface Options {
  title?: string;
  newCard?: boolean;
  savedCallback?: () => void;
  doneCallback?: () => void;
}

export const show = (userWord, options: Options) => {
  const editCardDialog = $("<div/>")
    .attr("id", "editCardDialog")
    .addClass("centralDialog");

  let unsavedChanges = false;

  editCardDialog.empty();
  preact.render(
    <EditCardView
      userWord={userWord}
      options={{ ...options, doneButton: !options.newCard }}
      phrase={/ /.test(userWord.get("word"))}
      doneCallback={() => {
        // Cancel modal dialog upon save
        modalDialog.cancel();
        options.doneCallback?.();
      }}
      savedCallback={() => {
        options.savedCallback?.();
      }}
    />,
    editCardDialog[0]
  );

  $("body").append(editCardDialog);
  modalDialog.show(editCardDialog, {
    confirmCancelCallback: function () {
      return (
        !unsavedChanges ||
        confirm("You have unsaved changes. Are you sure you want to close?")
      );
    },
    cancelCallback: function () {
      preact.render(null, editCardDialog[0]);
      editCardDialog.remove();
    },
  });

  const wordInput = editCardDialog.find('input[name="word"]');
  const translateInput = editCardDialog.find('input[name="translation"]');

  if (wordInput.val() === "") {
    wordInput.focus();
  } else if (translateInput.val() === "") {
    translateInput.focus();
  }
};
